<template>
  <div class="confirm">
    <b-container v-if="loading" class="section section--loader">
      <!--<b-spinner class="mt-4" />-->
      <loader size="large" :show_timing_slot="true" />
    </b-container>
    <div v-else>
      <b-container>
        <!--
                    test 
                    flight_voucher_id: 11
                    confirm_code: BLF7DZSX6
                    ////
                    http://localhost:8666/confirm/20/BLFPJ4MEW
                -->

        <section class="section section--title mb-3">
          <h1 class="h1 ml-0">Ottimo! La tua prenotazione è confermata</h1>

          <p v-if="redirect" class="text-size-lg ml-0 regular">
            (verrai reindirizzato al tuo portale tra
            <b>{{ redirect_counter > 0 ? redirect_counter : 0 }}</b> secondi...)
          </p>

          <!--<p class="text-size-lg ml-0 regular">
                        Ecco i riferimenti della tua prenotazione
                    </p>-->
        </section>

        <section class="section">
          <div class="confirm--panel" compact>
            <h5 class="h4 semibold">Riferimenti della prenotazione</h5>
            <!-- <h5 class="h5 bold">Riferimenti prenotazione {{ config.site.brand }}</h5> -->
            <div>
              <div v-if="flight_voucher.carrierReference">
                <p class="text-size-md mb-0">
                  Codice di riferimento della prenotazione
                </p>
                <p class="text-size-lg semibold">
                  {{ flight_voucher.carrierReference }}
                </p>
              </div>

              <p class="text-size-sm mb-0">Beneficiario</p>
              <p class="text-size-lg">
                {{ beneficiary.firstName }} {{ beneficiary.lastName }}
              </p>

              <p class="text-size-sm mb-0">Email di riferimento</p>
              <p class="text-size-lg">
                {{ beneficiary.email }}
              </p>

              <p class="text-size-sm mb-0">Codice di assistenza VadoBay</p>
              <p class="text-size-lg mb-0">
                {{ confirm_code }}
              </p>
              <small>
                (questo non è il codice del tuo volo ma il riferimento della
                prenotazione su
                {{ config.site.brand }}: usalo per comunicare con la nostra
                assistenza in caso di bisogno)
              </small>
            </div>
          </div>
        </section>

        <section class="section mt-4">
          <b-alert
            v-if="status == 'ISSUED'"
            variant="success"
            show
            class="d-flex"
          >
            <vb-icon name="email"></vb-icon>
            <div class="ml-2">
              Abbiamo inviato un'email di conferma all'indirizzo
              <span class="semibold">{{ beneficiary.email }}</span
              >. In alcuni casi potrebbero essere necessari anche oltre 10
              minuti dal momento del booking. Se non la trovi controlla anche la
              casella di spam. Se non hai ricevuto l'email di conferma
              contattaci al numero
              <span class="semibold">{{ config.site.phoneNumber }}</span> o
              all'indirizzo
              <span class="semibold">{{ config.site.emailSupport }}</span
              >.
            </div>
          </b-alert>
          <b-alert
            v-else-if="status == 'PENDING'"
            variant="warning"
            show
            class="d-flex"
          >
            <div>
              La prenotazione è definitivamente confermata solo nel momento in
              cui ricevi l'email di conferma che invieremo all'indirizzo
              <span class="semibold">{{ beneficiary.email }}</span
              >. In alcuni casi potrebbero essere necessari anche oltre 10
              minuti dal momento del booking. Controlla anche la casella di
              spam. Se sei sicuro di non avere ricevuto l'email di conferma
              contattaci al numero
              <span class="semibold">{{ config.site.phoneNumber }}</span> o
              all'indirizzo
              <span class="semibold">{{ config.site.emailSupport }}</span
              >.
            </div>
          </b-alert>
          <b-alert
            v-else-if="status == 'NOTCONFIRMED'"
            variant="danger"
            show
            class="d-flex"
          >
            <div>
              Ci sono stati alcuni problemi nel confermare la tua prenotazione.
              Ti invitiamo a contattarci appena possibile per ottenere il
              supporto di un nostro consulente
              <span class="semibold">{{ config.site.phoneNumber }}</span> o
              all'indirizzo
              <span class="semibold">{{ config.site.emailSupport }}</span
              >.
            </div>
          </b-alert>
          <b-alert v-else variant="danger" show class="d-flex">
            <!-- UNKNOWN o altro-->
            <div>
              Lo stato di questa prenotazione richiede una verifica. Contattaci
              al numero
              <span class="semibold">{{ config.site.phoneNumber }}</span> o
              all'indirizzo
              <span class="semibold">{{ config.site.emailSupport }}</span
              >.
            </div>
          </b-alert>
          <hr />
        </section>
      </b-container>

      <b-container>
        <section class="section section--title">
          <h1 class="h1 ml-0">Qui sotto trovi il riepilogo del tuo volo</h1>
        </section>

        <b-alert
          v-if="status == 'ISSUED'"
          variant="info"
          class="d-flex flex-column mb-4"
          show
        >
          <div class="h6-size semibold d-flex" style="gap: 5px">
            <vb-icon name="ticket" color="#246D78" class="title-icon"></vb-icon>
            <span>Check-in Online</span>
          </div>
          <p class="d-flex flex-column text-content" style="font-size: 12px">
            <span
              >24 ore prima della partenza ricorda di fare il check-in online
              sul sito della compagnia aerea e di scaricare le carte
              d’imbarco.</span
            >
            <span
              >Attenzione! Prendi nota di queste credenziali con cui effettuare
              l’accesso:</span
            >
          </p>
          <p class="d-flex flex-column" style="font-size: 12px">
            <span class="d-flex" style="gap: 5px"
              ><b class="text-content">Numero di prenotazione:</b
              ><b>{{ flight_voucher.carrierReference }}</b></span
            >
            <span class="d-flex" style="gap: 5px"
              ><b class="text-content">Mail:</b
              ><b>{{ flight_voucher.emailPnr }}</b></span
            >
          </p>
          <p class="d-flex flex-column text-content" style="font-size: 12px">
            Fare il chekin online è semplice: entra nella tua area riservata e
            segui le istruzioni della compagnia. Per dubbi o assistenza siamo a
            disposizione.
          </p>
        </b-alert>
        <b-row>
          <b-col sm="12" md="7" lg="8" xl="9">
            <div
              v-for="(flight_offer, index) in flight_voucher.orderData.data
                .flightOffers"
              :key="_uid + index"
            >
              <div class="confirm--panel" compact>
                <flight-pad-details :flight_offer="flight_offer" />
              </div>
              <!--<div class="confirm--panel" compact>
                                <h5 class="h5 semibold">Servizi</h5>
                                <div v-for="(traveler,index) in flight_offer.travelerPricings" v-bind:key="_uid + index">
                                    <p>
                                        Viaggiatore {{ traveler.travelerId }} - <span class="semibold">{{ traveler.price.total }} {{ traveler.price.currency }}</span>
                                    </p>

                                </div>
                            </div>-->
              <!--TODO qui ho i bagagli aggiuntivi divisi per viaggiatore e per segmento, capire come mostrarli-->
              <!--TODO capire come mostrare i bagagli inclusi-->
            </div>
            <div class="confirm--panel" compact>
              <h5 class="h5 semibold">Viaggiatori</h5>
              <b-row>
                <b-col
                  class="mb-2"
                  md="6"
                  v-for="(traveler, index) in flight_voucher.orderData.data
                    .travelers"
                  v-bind:key="_uid + index"
                >
                  <p class="text-size-sm mb-0">Nome</p>
                  <p class="text-size-lg mb-1">
                    {{ traveler.name.firstName }}
                    {{ traveler.name.middleName }} {{ traveler.name.lastName }}
                  </p>
                  <!--<p class="text-size-sm mb-0">
                                        Email
                                    </p>
                                    <p class="text-size-lg">
                                        {{ traveler.contact.emailAddress }}
                                    </p>--><!-- l'email non la chiediamo più (e viene forzata sotto al cofano quella dell'agenzia, non mostrarla)-->

                  <!-- alcune lccs tolgono i contacts dagli altri pax -->
                  <div v-if="traveler.contact && traveler.contact.phones">
                    <p class="text-size-sm mb-0">Telefono</p>
                    <p class="text-size-lg mb-1">
                      <span
                        class="d-block"
                        v-for="(phone, index_phone) in traveler.contact.phones"
                        v-bind:key="_uid + index_phone"
                      >
                        +{{ traveler.contact.phones[0].countryCallingCode }}
                        {{ traveler.contact.phones[0].number }}
                      </span>
                    </p>
                  </div>
                  <!-- tickets -->
                  <div
                    class="mb-2"
                    v-if="flight_voucher.orderData.data.tickets"
                  >
                    <div
                      v-for="(
                        ticket, ticket_index
                      ) in flight_voucher.orderData.data.tickets.filter((t) => {
                        return t.travelerId == traveler.id;
                      })"
                      v-bind:key="`sId${_uid}${ticket_index}`"
                    >
                      <div
                        class="mb-0"
                        v-for="(
                          ticket_segment, ticket_segment_index
                        ) in ticket.segmentIds"
                        v-bind:key="`s${_uid}tsid${ticket_segment_index}`"
                      >
                        <div
                          v-for="(itinerary, itinerary_index) in flight_voucher
                            .orderData.data.flightOffers[0].itineraries"
                          v-bind:key="`i${_uid}i${itinerary_index}`"
                        >
                          <div
                            v-for="(
                              segment, segment_index
                            ) in itinerary.segments"
                            v-bind:key="`i${_uid}s${segment_index}`"
                          >
                            <!-- ckeck per non replicare segmenti in ticket con un solo itinerario-->
                            <div
                              v-if="
                                (flight_voucher.orderData.data.flightOffers[0]
                                  .itineraries.length == 1 &&
                                  segment_index == 0) ||
                                flight_voucher.orderData.data.flightOffers[0]
                                  .itineraries.length > 1
                              "
                            >
                              <div v-if="segment.id == ticket_segment">
                                <!--ticket_segment: {{ ticket_segment }}-->
                                <div
                                  class="mt-1"
                                  v-if="ticket.documentType == 'ETICKET'"
                                >
                                  <div class="d-flex align-center">
                                    <div class="mr-2">
                                      <b-badge variant="cta">{{
                                        ticket.documentType
                                      }}</b-badge>
                                    </div>
                                    <div class="d-flex mr-1">
                                      <div>
                                        {{
                                          itinerary.segments[0].departure
                                            .iataCode
                                        }}
                                      </div>
                                      <div class="mx-1">-</div>
                                      <div class="mr-1">
                                        {{
                                          itinerary.segments[
                                            itinerary.segments.length - 1
                                          ].arrival.iataCode
                                        }}
                                      </div>
                                      <div>
                                        ({{
                                          reverse_date(
                                            itinerary.segments[0].departure.at,
                                          )
                                        }})
                                      </div>
                                    </div>
                                  </div>

                                  <!-- status and services by segment -->
                                  <div
                                    class="pl-2"
                                    :set_traveler_pricing="
                                      (traveler_pricing =
                                        flight_voucher.orderData.data.flightOffers[0].travelerPricings.filter(
                                          (t) => {
                                            return t.travelerId == traveler.id;
                                          },
                                        )[0])
                                    "
                                  >
                                    <div>
                                      <small class="mr-1"
                                        >Ticket number:
                                        {{ ticket.documentNumber }}</small
                                      >
                                      <b-badge
                                        :variant="
                                          ticket.documentStatus == 'ISSUED'
                                            ? 'success'
                                            : 'warning'
                                        "
                                        >{{ ticket.documentStatus }}</b-badge
                                      >
                                    </div>

                                    <div
                                      :set_fare_details_by_segment="
                                        (fare_details_by_segment = (
                                          traveler_pricing.fareDetailsBySegment ||
                                          []
                                        ).filter((f) => {
                                          return f.segmentId == segment.id;
                                        })[0])
                                      "
                                    ></div>
                                    <template v-if="fare_details_by_segment">
                                      <div
                                        v-if="
                                          fare_details_by_segment.includedCheckedBags
                                        "
                                      >
                                        <small
                                          >Included checked bags:
                                          {{
                                            fare_details_by_segment
                                              .includedCheckedBags.quantity
                                          }}</small
                                        >
                                      </div>
                                      <div
                                        v-if="
                                          fare_details_by_segment.mealServices
                                        "
                                      >
                                        <div
                                          v-for="(
                                            meal_service, meal_service_index
                                          ) in fare_details_by_segment.mealServices"
                                          v-bind:key="`ms${meal_service_index}`"
                                        >
                                          <small
                                            >Meal services: "{{
                                              meal_service.label
                                            }}"</small
                                          >
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                </div>
                                <div
                                  v-if="ticket.documentType == 'EMD'"
                                  class="mt-1"
                                >
                                  <div class="d-flex align-center">
                                    <div class="mr-2">
                                      <b-badge variant="primary">{{
                                        ticket.documentType
                                      }}</b-badge>
                                    </div>
                                    <div class="d-flex mr-2">
                                      <div>
                                        {{
                                          itinerary.segments[0].departure
                                            .iataCode
                                        }}
                                      </div>
                                      <div class="mx-1">-</div>
                                      <div class="mr-1">
                                        {{
                                          itinerary.segments[
                                            itinerary.segments.length - 1
                                          ].arrival.iataCode
                                        }}
                                      </div>
                                      <div>
                                        ({{
                                          reverse_date(
                                            itinerary.segments[0].departure.at,
                                          )
                                        }})
                                      </div>
                                    </div>
                                  </div>
                                  <div class="pl-2">
                                    <div class="mr-2">
                                      <div>
                                        <small class="mr-1"
                                          >Ticket number:
                                          {{ ticket.documentNumber }}</small
                                        >
                                        <b-badge
                                          :variant="
                                            ticket.documentStatus == 'ISSUED'
                                              ? 'success'
                                              : 'warning'
                                          "
                                          >{{ ticket.documentStatus }}</b-badge
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="traveler.documents">
                    <p class="text-size-sm mb-0">Documento</p>
                    <p class="text-size-lg">
                      <span
                        class="d-block"
                        v-for="(document, index_document) in traveler.documents"
                        v-bind:key="_uid + index_document"
                      >
                        Numero: {{ document.number }} - Scadenza:
                        {{ document.expiryDate }}
                      </span>
                    </p>
                  </div>
                </b-col>
              </b-row>
            </div>

            <additional-services-booked
              v-if="flight_offer"
              :flight_offer="flight_offer"
              :travelers="flight_voucher.orderData.data.travelers"
            />

            <div class="confirm--panel" compact>
              <h5 class="h4 semibold d-flex" style="gap: 5px">
                <vb-icon name="ticket" class="title-icon"></vb-icon>
                <span>Check-in Online</span>
              </h5>
              <p v-if="checkin_online_info" v-html="checkin_online_info"></p>
              <p v-else>
                Questo documento e il codice riportato in questa email non ti
                danno diritto all'imbarco. Per effettuare l'imbarco devi
                effettuare il check-in online prima della partenza. Il check-in
                online va obbligatoriamente effettuato sul sito della compagnia
                aerea nei termini e nelle modalità indicate sul sito stesso. Ti
                invitiamo a visitare e consultare il sito della compagnia aerea
                con attenzione
              </p>
            </div>

            <div class="confirm--panel" compact v-if="status == 'ISSUED'">
              <div class="h3 ml-0 mb-1">
                Accedi alla tua prenotazione sul sito della compagnia aerea
              </div>
              <p>
                Accedi sul sito della compagnia utilizzando il codice
                <b>{{ flight_voucher.carrierReference }}</b> ed il nominativo
                <b>{{ flight_voucher.contactNameSurname }}</b>
                <br />
                <small
                  >(nel caso in cui venisse richiesto anche un indirizzo email,
                  utilizza <b>{{ flight_voucher.emailPnr }}</b
                  >)</small
                >
              </p>
              <hr />
              <div class="h3 ml-0 mb-1">I tuoi bagagli</div>
              <p>
                Per avere una descrizione completa delle condizioni di imbarco
                dei tuoi bagagli relativamente a franchigie, peso, dimensioni,
                accedi alla tua prenotazione sul sito della compagnia aerea
                seguendo le istruzioni indicate qui sopra.
              </p>
              <hr />
              <div class="h3 ml-0 mb-1">Gestione della prenotazione</div>
              <p>
                Tutte le possibili opzioni di gestione della tua prenotazione
                sono disponibili facendo accesso al sito della compagnia
                seguendo le istruzioni riportate qui sopra.
              </p>
              <hr />
              <div class="h3 ml-0 mb-1">Acquisito di servizi aggiuntivi</div>
              <p>
                Sul sito della compagnia, se non già inclusi nella tariffa che
                hai prenotato, potrai aggiungere alla tua prenotazione una ampia
                lista di servizi come posti selezionati, imbarco prioritario,
                bagagli aggiuntivi, bagagli speciali, ecc.
              </p>
              <hr />
              <div class="h3 ml-0 mb-1">Covid</div>
              <p>
                Trovi le informazioni adeguate relativamente alle normative di
                sicurezza Covid sul sito
                <a href="https://www.viaggiaresicuri.it/home" target="_blank"
                  >Viaggiare sicuri</a
                >
                del Ministero degli esteri e sul sito della compagnia aerea.
              </p>
              <hr />
              <div class="h3 ml-0 mb-1">
                Richieste di assistenza ed esigenze speciali
              </div>
              <p>
                Se hai necessità di una assistenza speciale per motivi di
                disabilità o salute ti invitiamo a contattare la compagnia
                aerea. Lo stesso consiglio vale per esigenze alimentari
                speciali.
              </p>
            </div>
          </b-col>
          <b-col m="12" md="5" lg="4" xl="3">
            <div class="confirm--panel pt-0" compact>
              <!--<sidebar-resume
                                :flight_offers="[flight_offer]"
                                :post_sell_notice="post_sell_notice"
                            />-->
              <div class="mt-4 pt-3 d-flex justify-content-between">
                <h3 class="h3 mb-0">Totale</h3>
                <h3 class="h3 mb-0">{{ flight_voucher.live_price }} EUR</h3>
              </div>
              <div>
                <p class="mb-2" style="margin-top: 10px">
                  Tariffa, tasse e spese amministrative per tutti i partecipanti
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { service_handler } from "@/services";
import { reverse_date } from "@/utilities/commons";
import FlightPadDetails from "@liveflight/components/blocks/flight-pad/flight-pad-details/flight-pad-details";
import AdditionalServicesBooked from "@liveflight/components/blocks/additional-services-booked.vue";

export default {
  name: "confirm",
  components: {
    "additional-services-booked": AdditionalServicesBooked,
    "flight-pad-details": FlightPadDetails,
  },
  props: {
    confirm_code: String,
    flight_voucher_id: String,
    ignore_redirect: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      flight_voucher: {},
      beneficiary: {},
      flight_offer: {},
      config: Vue.prototype.$config,
      status: "",
      post_sell_notice: {},
      redirect: false,
      redirect_counter: 30,
      checkin_online_info: "",
    };
  },
  created() {
    this.reverse_date = reverse_date;
  },
  mounted() {
    let _this = this;
    if (
      !this.ignore_redirect &&
      Vue.prototype.$config.integration &&
      Vue.prototype.$config.integration.orderConfirmedRedirectTo
    ) {
      _this.redirect = true;
      let counter = window.setInterval(function () {
        if (_this.redirect_counter <= 0) {
          clearInterval(counter);
          window.location.href =
            Vue.prototype.$config.integration.orderConfirmedRedirectTo;
        }
        _this.redirect_counter = _this.redirect_counter - 1;
      }, 1000);
    }

    this.confirm({
      flightVoucherId: this.flight_voucher_id,
      confirmcode: this.confirm_code,
    })
      .then((response) => {
        if (response.flightVoucher.mu) {
          this.config.forced_mu = response.flightVoucher.mu;
        }
        this.flight_offer =
          response.flightVoucher.orderData.data.flightOffers[0];
        this.flight_voucher = response.flightVoucher;
        this.checkin_online_info = response.checkinOnlineInfo || "";
        this.beneficiary = response.beneficiary;
        this.status = response.status;
        this.$store.commit("liveflight/results", {
          dictionaries: response.flightVoucher.orderData.dictionaries,
        });

        if (response.postSellNotice)
          this.post_sell_notice = response.postSellNotice;

        this.loading = false;
      })
      .finally(() => {
        this.scroll_top();
      });
  },
  methods: {
    confirm(request) {
      return service_handler("confirm", request).then(
        (response) => response.data,
      );
    },
  },
};
</script>

<style lang="scss">
.confirm {
  .title-icon {
    margin-top: -2px;
  }
  &--panel {
    @extend .content-panel !optional;
    margin-bottom: 1rem !important;
  }
}
</style>
